const BASE = "https://rsud.mataramkota.go.id"
export const baseURL_R_file = BASE + ":1200/"
export const baseURL_R = BASE + ":1200/api"

 
export const BASE_URL_SOCKET = BASE + ":9035";
